import { render, staticRenderFns } from "./BajasComercialesPantalla.vue?vue&type=template&id=3c252030&"
import script from "./BajasComercialesPantalla.vue?vue&type=script&lang=ts&"
export * from "./BajasComercialesPantalla.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('3c252030', component.options)
    } else {
      api.reload('3c252030', component.options)
    }
    module.hot.accept("./BajasComercialesPantalla.vue?vue&type=template&id=3c252030&", function () {
      api.rerender('3c252030', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/Conecta/BajasComerciales/BajasComercialesPantalla.vue"
export default component.exports